import { Button, Form, Input, Select } from "antd";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";

import { getAllMaster } from "../../redux/rtk/features/masters/masterSlice";
import { addSingleAwardType } from "../../redux/rtk/features/award/awardSlice";

const { Option } = Select;

const AddAwardType = ({ onSuccess }) => {
  const [form] = Form.useForm();
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const masterData = useSelector((state) => state.masters.masters);

  useEffect(() => {
    dispatch(getAllMaster());
  }, [dispatch]);

  const onFinish = async (values) => {
    setLoader(true);
    try {
      const awardTypeData = {
        AwardTypeId: 0,
        AwardFrequencyId: values.AwardFrequencyId,
        AwardTypeName: values.AwardTypeName,
        NominationWeekId: values.NominationWeekIdneither,
        NominationDayId: values.NominationDayId,
        DistributionWeekId: values.DistributionWeekId,
        DistributionDayId: values.DistributionDayId,
        DataStatus: 1,
      };
      const resp = await dispatch(addSingleAwardType(awardTypeData));

      if (resp.payload.message === "success") {
        setLoader(false);
        form.resetFields();
        toast.success("Award Type added successfully");
        onSuccess(); // Close modal and refresh award types
      } else {
        setLoader(false);
        toast.error("Failed to add award type");
      }
    } catch (error) {
      setLoader(false);
      toast.error("An error occurred while adding the award type");
      // console.error(error);
    }
  };

  const onFinishFailed = (errorInfo) => {
    toast.warning("Failed at adding award type");
    setLoader(false);
  };

  return (
    <Form
      form={form}
      name="add-award-type"
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 16 }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
    >
      <Form.Item
        label="Award Type Name"
        name="AwardTypeName"
        rules={[
          {
            required: true,
            message: "Please input the award type name!",
          },
        ]}
      >
        <Input placeholder="Test" />
      </Form.Item>

      <Form.Item
        label="Award Frequency"
        name="AwardFrequencyId"
        rules={[
          {
            required: true,
            message: "Please select an award frequency!",
          },
        ]}
      >
        <Select placeholder="Select Frequency">
          {masterData?.AwardFrequency &&
            masterData?.AwardFrequency.map((freq) => (
              <Option key={freq.AwardFrequencyId} value={freq.AwardFrequencyId}>
                {freq.AwardFrequencyName}
              </Option>
            ))}
        </Select>
      </Form.Item>

      <Form.Item
        label="Nomination Week"
        name="NominationWeekId"
        rules={[
          {
            required: true,
            message: "Please select a nomination week!",
          },
        ]}
      >
        <Select placeholder="Select Week">
          {masterData?.WeeklyNumberMaster &&
            masterData?.WeeklyNumberMaster.map((week) => (
              <Option key={week.WeeklyNumberId} value={week.WeeklyNumberId}>
                {week.WeeklyNumberName}
              </Option>
            ))}
        </Select>
      </Form.Item>

      <Form.Item
        label="Nomination Day"
        name="NominationDayId"
        rules={[
          {
            required: true,
            message: "Please select a nomination day!",
          },
        ]}
      >
        <Select placeholder="Select Day">
          {masterData?.WeeklyDayMaster &&
            masterData?.WeeklyDayMaster.map((day) => (
              <Option key={day.WeeklyDayId} value={day.WeeklyDayId}>
                {day.WeeklyDayName}
              </Option>
            ))}
        </Select>
      </Form.Item>

      <Form.Item
        label="Distribution Week"
        name="DistributionWeekId"
        rules={[
          {
            required: true,
            message: "Please select a distribution week!",
          },
        ]}
      >
        <Select placeholder="Select Week">
          {masterData?.WeeklyNumberMaster &&
            masterData?.WeeklyNumberMaster.map((week) => (
              <Option key={week.WeeklyNumberId} value={week.WeeklyNumberId}>
                {week.WeeklyNumberName}
              </Option>
            ))}
        </Select>
      </Form.Item>

      <Form.Item
        label="Distribution Day"
        name="DistributionDayId"
        rules={[
          {
            required: true,
            message: "Please select a distribution day!",
          },
        ]}
      >
        <Select placeholder="Select Day">
          {masterData?.WeeklyDayMaster &&
            masterData?.WeeklyDayMaster.map((day) => (
              <Option key={day.WeeklyDayId} value={day.WeeklyDayId}>
                {day.WeeklyDayName}
              </Option>
            ))}
        </Select>
      </Form.Item>

      <Form.Item
        wrapperCol={{
          offset: 8,
          span: 16,
        }}
      >
        <Button
          type="primary"
          htmlType="submit"
          loading={loader}
        >
          Add Award Type
        </Button>
      </Form.Item>
    </Form>
  );
};

export default AddAwardType;